import {useMemo} from 'react'
import {graphql, useSubscription} from 'react-relay'

import type {useRecentAgentActivitySubscription} from './__generated__/useRecentAgentActivitySubscription.graphql'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const recentAgentActivitySubscription = graphql`
  subscription useRecentAgentActivitySubscription($issueId: ID!) {
    issueUpdated(id: $issueId) {
      updateIntentChanged {
        ...useRecentAgentActivity_issue
      }
    }
  }
`

/**
 * Subscribes to real-time pending agent suggestion updates for an issue.
 *
 * Subscribes to suggestion-specific issue update payloads so only pending
 * suggestion changes refresh this panel, keeping subscription updates scoped.
 */
export function useRecentAgentActivitySubscription(issueId: string) {
  const config = useMemo(
    () => ({
      subscription: recentAgentActivitySubscription,
      variables: {issueId},
    }),
    [issueId],
  )

  useSubscription<useRecentAgentActivitySubscription>(config)
}
